// Purpose of this file is to send tracking events to Google

/**
 * Get data from passed actions and push it in dataLayer for Google Analytics
 *
 * @param {string} event_action - event action string
 */
export const googleTracker = ( event_action = '' ) => {
	if ( ! event_action || ! window?.dataLayer ) {
		return;
	}

	const event = 'trackElement';

	const meta_tag = document.querySelector( 'meta[name="sc:country"]' );
	const country = ( meta_tag ) ? meta_tag.getAttribute( 'content' ) : null;
	const title = window?.document?.title || '';

	const current_url = window?.location?.href || '';

	const dataSet = {
		event: event,
		eventCategory: `~${ country } : ^${ title }`,
		eventAction: event_action,
		eventLabel: current_url,
	};

	window?.dataLayer.push( dataSet );
};
